import { useCallback, useEffect, useState } from 'react'
import { getRoles } from '@/lib/auth'
import { USER_ROLE_KEYS } from '@/constants/roles'

export type Density = 'comfortable' | 'compact'

const DENSITY_STORAGE_KEY = 'panel.density'

const COMPACT_DEFAULT_ROLES: string[] = [
  USER_ROLE_KEYS.AGENT,
  USER_ROLE_KEYS.DISPOSER,
  USER_ROLE_KEYS.C2B_OPS_FF_CHALLAN_DISPOSE_VAS,
]

function readDensity(): Density {
  try {
    const stored = localStorage.getItem(DENSITY_STORAGE_KEY)
    if (stored === 'compact' || stored === 'comfortable') return stored
  } catch {
    // ignore
  }
  const roles = getRoles()
  const isFieldRole = roles.length > 0 && roles.every((r) => COMPACT_DEFAULT_ROLES.includes(r))
  return isFieldRole ? 'compact' : 'comfortable'
}

/** Per-user density. Writes `data-density` on <html>; only spacing and heights change, never font sizes. */
export function useDensity() {
  const [density, setDensityState] = useState<Density>(readDensity)

  useEffect(() => {
    document.documentElement.dataset.density = density
  }, [density])

  const setDensity = useCallback((next: Density) => {
    try {
      localStorage.setItem(DENSITY_STORAGE_KEY, next)
    } catch {
      // ignore
    }
    setDensityState(next)
  }, [])

  return { density, setDensity }
}
